import React from 'react';
import { Switch, Route } from 'react-router-dom';
import {
  withAttSub,
  withSimoSub,
  withQuickSub,
  withSprintSub,
  withTracfoneSub,
} from './withSub';
import withUser from './withUser';
import withPurchase from './withPurchase';
import withPreactivation from './withPreactivation';
import withCredit from './withCredit';
import withSimoDevice from './withSimoDevice';

const withUserTopNav = (DecoratedComponent) => {
  const WithUser = withUser(DecoratedComponent);
  const WitAttSub = withAttSub(DecoratedComponent);
  const WithSimoSub = withSimoSub(DecoratedComponent);
  const WithSimoDevice = withSimoDevice(DecoratedComponent);
  const WithQuickSub = withQuickSub(DecoratedComponent);
  const WithSprintSub = withSprintSub(DecoratedComponent);
  const WithTracfoneSub = withTracfoneSub(DecoratedComponent);
  const WithPurchase = withPurchase(DecoratedComponent);
  const WithPreactivation = withPreactivation(DecoratedComponent);
  const WithCredit = withCredit(DecoratedComponent);

  let WithUserTopNav = (props) => {
    return (
      <Switch>
        <Route
          path="/subscriptions/:subId"
          component={WithSprintSub}
          {...props}
        />
        <Route
          path="/att/subscriptions/:subId"
          component={WitAttSub}
          {...props}
        />
        <Route
          path="/simo/subscriptions/:subId"
          component={WithSimoSub}
          {...props}
        />
        <Route
          path="/quick/subscriptions/:subId"
          component={WithQuickSub}
          {...props}
        />
        <Route
          path="/tracfone/subscriptions/:subId"
          component={WithTracfoneSub}
          {...props}
        />
        <Route
          path="/simo/devices/:deviceId"
          component={WithSimoDevice}
          {...props}
        />
        <Route path="/users/:userId" component={WithUser} {...props} />
        <Route
          path="/purchases/:purchaseId"
          component={WithPurchase}
          {...props}
        />
        <Route
          path="/preactivations/:preactivationId"
          component={WithPreactivation}
          {...props}
        />
        <Route path="/credits/:creditId" component={WithCredit} {...props} />
      </Switch>
    );
  };

  return WithUserTopNav;
};

export default withUserTopNav;
